import { css } from "styled-components";
export const outlineBorderCSS = css `
  outline: 2px solid transparent;
  outline-offset: -2px;
`;
export const outlineBorderActiveBlueCSS = css `
  outline-color: ${({ theme }) => theme.systemColors.blue600};
`;
export const outlineBorderActiveRedCSS = css `
  outline-color: ${({ theme }) => theme.systemColors.red400};
`;
